import { useTranslation } from "react-i18next";

import type { GenderSelect } from "./appointment-form.types";

export function useGenderOptions(): GenderSelect[] {
  const { t } = useTranslation();

  return [
    {
      label: t("Male"),
      value: "male",
    },
    {
      label: t("Female"),
      value: "female",
    },
    {
      label: t("Other"),
      value: "other",
    },
  ];
}
